<div
  class="input-wrapper"
  [class.has-error]="showError"
  [style.opacity]="disabled() || isDisabled ? 0.5 : 1"
>
  <div class="label-container">
    @if (label()) {
      <div class="label-wrapper">
        <label [for]="id()">
          {{ label() }}
          @if (isRequired) {
            <span class="required">*</span>
          }
        </label>
        @if (tooltip()) {
          <lib-tooltip [tooltip]="tooltip()">
            <i-feather
              name="info"
              class="info-icon"
            ></i-feather>
          </lib-tooltip>
        }
      </div>
    }
    @if (showError) {
      <small class="error-message">
        {{ getErrorMessage() }}
      </small>
    }
  </div>
  <div
    class="input-container"
    [ngClass]="rounded() ? 'rounded' : ''"
  >
    @if (prefix()) {
      <div class="input-prefix">
        <i-feather
          [name]="prefix()"
          [style.width.px]="36 * 0.5"
          [style.height.px]="36 * 0.5"
          [style.color]="'var(--placeholder-color)'"
        ></i-feather>
      </div>
    }
    <input
      #inputElement
      [id]="id()"
      [type]="type()"
      [attr.maxlength]="maxlength() ? maxlength() : null"
      [value]="displayValue"
      [placeholder]="placeholder() || ''"
      [required]="required()"
      [disabled]="disabled() || isDisabled"
      [readonly]="readOnly()"
      (input)="handleInput($event)"
      (blur)="onBlur()"
      (paste)="onPaste($event)"
      [autocomplete]="autocomplete()"
      (focus)="handleFocus.emit()"
      [ngClass]="rounded() ? 'rounded' : ''"
    />
    @if (shortcut()) {
      <div class="input-shortcut">
        <span class="shortcut-text">{{ shortcut() }}</span>
      </div>
    }
    @if (suffix()) {
      <div class="input-suffix">
        <i-feather
          [name]="suffix()"
          [style.width.px]="36 * 0.5"
          [style.height.px]="36 * 0.5"
          [style.color]="'var(--placeholder-color)'"
        ></i-feather>
      </div>
    }
  </div>
</div>
